import { render, staticRenderFns } from "./ShowObjectDialog.vue?vue&type=template&id=786ec2c6&scoped=true&"
import script from "./ShowObjectDialog.vue?vue&type=script&lang=ts&"
export * from "./ShowObjectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShowObjectDialog.vue?vue&type=style&index=0&id=786ec2c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786ec2c6",
  null
  
)

export default component.exports